<form class="left-right-selection-box" #leftRightSelectionBoxForm="ngForm">
    <div class="left-content" [resBusySpinner]="isBusyLeft" [message]="isBusyMessageLeft"
        [ngStyle]="{'width': showLeftRightButton ? 'calc(' + leftListSize + '% - 25px)' : 'calc(' + leftListSize + '%)'}">
        <div class="content-header">
            <div class="title" *ngIf="leftListTitle">
                <span requiredAsterisk [isRequired]="leftListRequired">{{leftListTitle}} </span>
            </div>
            <div class="template" *ngIf="leftListTemplate">
                <ng-container *ngTemplateOutlet="leftListTemplate"></ng-container>
            </div>
        </div>
        <div *ngIf="!useTrees" class="list-container"
            [ngClass]="[adjustHeaderCheckboxStyles ? 'header-checkbox-style' : '']">
            <res-generic-grid [customGridClass]="'ag-no-odd-even-rows' + (useDragAndDrop ? ' ag-drag-and-drop' : '')"
                [ngClass]="[isMetadataViewFieldsRefined()]" [automationId]="automationIdLeft"
                [rowSelection]="leftListSelection" [columnDefs]="leftListColumns"
                [responseCallback]="leftListResponseCallback" [onCustomFilterCallback]="onCustomFilterCallbackLeftGrid"
                [responseArrayCallback]="leftListResponseArrayCallback" [requestInfo]="leftListRequestInfo"
                [pagerTemplate]="leftListPagerTemplate" [pagerVisible]="leftListPagerVisible"
                [pagerName]="leftListPagerName" [gridContext]="leftListGridContext" [rowHeight]="leftListHeight"
                [headerHeight]="leftListHeaderHeight" [rowHeightCallback]="leftListRowHeightCallback"
                [onSelectionChanged]="leftListOnSelectionChanged"
                [hasCustomCellTemplates]="!hasMetadataViewFieldsPermission() && useDragAndDrop"
                [rowClassRules]="leftGridRowClassRules">
            </res-generic-grid>
        </div>
        <div *ngIf="useTrees" class="tree-container modal-fill">
            <res-generic-tree customClasses="generic-tree-header-panels generic-tree-node-border-bottom"
                [automationId]="automationIdLeft" [initialData]="itemsLeft" [isMultiSelect]="true"
                [hasSelectionColumn]="leftListHasSelectionColumn" [rowHeight]="leftListHeight"
                [checkboxSelectionChangedCallback]="checkboxSelectionChangedCallbackLeft"></res-generic-tree>
        </div>
    </div>
    <div class="left-right-button" *ngIf="showLeftRightButton">
        <button type="button" [attr.data-automation-id]="buttonId()" class="secondary-button" (click)="moveItems()"
            [disabled]="!buttonMode()" [ngClass]="{'add' : buttonMode() == 'add', 'remove' : buttonMode() == 'remove'}"
            *ngIf="!hasViewOnlyPermissions">
            <div>
                <i class="fa fa-arrow-right" [hidden]="buttonMode() == 'remove'"></i>
                <div [hidden]="buttonMode()"></div>
                <i class="fa fa-arrow-left" [hidden]="buttonMode() == 'add'"></i>
            </div>
        </button>
    </div>
    <div class="vertical-spacer" *ngIf="!showLeftRightButton"></div>
    <div class="right-content"
        [ngStyle]="{'width': showLeftRightButton ? 'calc(' + (100 - leftListSize) + '% - 25px)' : 'calc(' + (100 - leftListSize) + '% )'}">
        <div class="content-header">
            <div class="title" *ngIf="rightListTitle && rightListRequired">
                <span requiredAsterisk [titleStr]="rightListRequiredTooltip">{{rightListTitle}}</span>
            </div>
            <div class="title" *ngIf="rightListTitle && !rightListRequired">
                <span>{{rightListTitle}}</span>
            </div>
            <div class="template" *ngIf="rightListTemplate">
                <ng-container *ngTemplateOutlet="rightListTemplate"></ng-container>
            </div>
        </div>
        <div *ngIf="!useTrees" class="list-container"
            [ngClass]="[adjustHeaderCheckboxStyles ? 'header-checkbox-style' : '']">
            <res-generic-grid [customGridClass]="'ag-no-odd-even-rows' + (useDragAndDrop ? ' ag-drag-and-drop' : '')"
                [ngClass]="[isMetadataViewFieldsRefined()]" [automationId]="automationIdRight"
                [rowSelection]="rightListSelection" [pagerVisible]="false" [columnDefs]="rightListColumns"
                [gridContext]="rightListGridContext" [rowHeight]="rightListHeight"
                [headerHeight]="rightListHeaderHeight" [rowHeightCallback]="rightListRowHeightCallback"
                [onSelectionChanged]="rightListOnSelectionChanged" [rowClassRules]="rowClassRules"
                [onCustomFilterCallback]="onCustomFilterCallbackRightGrid"
                [hasCustomCellTemplates]="!hasMetadataViewFieldsPermission() && useDragAndDrop"
                [showHeaderContextMenu]="showRightHeaderContextMenu">
            </res-generic-grid>
        </div>
        <div *ngIf="useTrees" class="tree-container modal-fill right-tree">
            <res-generic-tree customClasses="generic-tree-node-border-bottom" [automationId]="automationIdRight"
                [initialData]="itemsRight" [isMultiSelect]="true" [hasSelectionColumn]="rightListHasSelectionColumn"
                [rowHeight]="rightListHeight"
                [checkboxSelectionChangedCallback]="checkboxSelectionChangedCallbackRight"></res-generic-tree>
        </div>
        <div class="bottom-template" *ngIf="rightListBottomTemplate">
            <ng-container *ngTemplateOutlet="rightListBottomTemplate"></ng-container>
        </div>
    </div>
</form>